import gql from 'graphql-tag';

import integrationItemFragment from '../fragments/integrationItemFragment';

export const mutationCreateIntegrationFolder = gql`
  mutation createIntegrationFolder(
    $integrationID: DokkioID!
    $name: String!
    $parentRemoteID: ID!
    $dokkioTagIDs: [DokkioID!]
  ) {
    createIntegrationFolder(
      integrationID: $integrationID
      name: $name
      parentRemoteID: $parentRemoteID
      dokkioTagIDs: $dokkioTagIDs
    ) {
      ...integrationItemFragment
    }
  }
  ${integrationItemFragment}
`;
export default mutationCreateIntegrationFolder;
